import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Image from 'global/Image';
import { format, parseISO } from 'date-fns';
import numeral from 'numeral';
import { CouponDetailItemContainer } from './styled';

interface CouponDetailProps {
  annualRate: string;
  dueDate: string;
  minimumOrder: string;
  nextDate: string;
  couponDistribution: string;
  issuedDate: string;
  issuer: string;
}

const CouponDetail = (props: CouponDetailProps) => {
  const {
    annualRate,
    couponDistribution,
    dueDate,
    issuedDate,
    minimumOrder,
    nextDate,
    issuer,
  } = props;
  return (
    <>
      <CouponDetailItemContainer>
        <Flex align="center">
          <Image src="/icon/fr/coupon-rate.svg" />
          {/* @ts-expect-error */}
          <Flex direction="column" ml="12px">
            {/* @ts-expect-error */}
            <Text color="#858585" mb="4px">
              Tingkat Kupon / Tahun
            </Text>
            <Text weight="bold">
              {annualRate}%
            </Text>
          </Flex>
        </Flex>
        <Flex align="center">
          <Image src="/icon/fr/coupon-due-date.svg" />
          {/* @ts-expect-error */}
          <Flex direction="column" ml="12px">
            {/* @ts-expect-error */}
            <Text color="#858585" mb="4px">
              Jatuh Tempo
            </Text>
            <Text weight="bold">
              {format(parseISO(dueDate), 'dd MMM yyyy')}
            </Text>
          </Flex>
        </Flex>
      </CouponDetailItemContainer>
      <CouponDetailItemContainer>
        <Flex align="center">
          <Image src="/icon/fr/coupon-minimum-purchase.svg" />
          {/* @ts-expect-error */}
          <Flex direction="column" ml="12px">
            {/* @ts-expect-error */}
            <Text color="#858585" mb="4px">
              Minimum Pembelian
            </Text>
            <Text weight="bold">
              1 Unit (Rp{numeral(minimumOrder).format('0,0')})
            </Text>
          </Flex>
        </Flex>
        <Flex align="center">
          <Image src="/icon/fr/coupon-next-date.svg" />
          {/* @ts-expect-error */}
          <Flex direction="column" ml="12px">
            {/* @ts-expect-error */}
            <Text color="#858585" mb="4px">
              Tanggal Kupon Berikutnya
            </Text>
            <Text weight="bold">
              {format(parseISO(nextDate), 'dd MMM yyyy')}
            </Text>
          </Flex>
        </Flex>
      </CouponDetailItemContainer>
      <CouponDetailItemContainer>
        <Flex align="center">
          <Image src="/icon/fr/coupon-period.svg" />
          {/* @ts-expect-error */}
          <Flex direction="column" ml="12px">
            {/* @ts-expect-error */}
            <Text color="#858585" mb="4px">
              Pembagian Kupon
            </Text>
            <Text weight="bold">
              {couponDistribution}
            </Text>
          </Flex>
        </Flex>
        <Flex align="center">
          <Image src="/icon/fr/coupon-publication.svg" />
          {/* @ts-expect-error */}
          <Flex direction="column" ml="12px">
            {/* @ts-expect-error */}
            <Text color="#858585" mb="4px">
              Tanggal Penerbitan
            </Text>
            <Text weight="bold">
              {format(parseISO(issuedDate), 'dd MMM yyyy')}
            </Text>
          </Flex>
        </Flex>
      </CouponDetailItemContainer>
      {/* @ts-expect-error */}
      <Flex align="center" mt="16px" mb="16px">
        <Image src="/icon/fr/coupon-publisher.svg" />
        {/* @ts-expect-error */}
        <Flex direction="column" ml="12px">
          {/* @ts-expect-error */}
          <Text color="#858585" mb="4px">
            Penerbit
          </Text>
          <Text weight="bold">
            {issuer}
          </Text>
        </Flex>
      </Flex>
    </>
);
};

export default CouponDetail;
